import React, { memo } from "react";

function BarraNavegacionInferior({
  onInicio,
  onFavoritos,
  onCarrito,
  onCuenta,
  favoritos = 0,
  carrito = 0,
}) {
  return (
    <nav
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        height: "70px",
        background: "rgba(255,255,255,.96)",
        backdropFilter: "blur(14px)",
        WebkitBackdropFilter: "blur(14px)",
        borderTop: "1px solid #ececec",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        boxShadow: "0 -8px 22px rgba(0,0,0,.06)",
        zIndex: 80,
      }}
    >
      <Boton
        icono="🏠"
        texto="Inicio"
        activo
        onClick={
          onInicio ||
          (() =>
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            }))
        }
      />

      <Boton
        icono="❤️"
        texto="Favoritos"
        badge={favoritos}
        onClick={onFavoritos}
      />

      <Boton icono="🛒" texto="Carrito" badge={carrito} onClick={onCarrito} />

      <Boton icono="☰" texto="Menú" activo={false} onClick={onCuenta} />
    </nav>
  );
}

function Boton({ icono, texto, badge = 0, activo = false, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        border: "none",
        background: "transparent",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "4px",
        cursor: "pointer",
        color: activo ? "#111" : "#666",
        minWidth: "62px",
        position: "relative",
        transition: ".2s",
      }}
    >
      <div
        style={{
          position: "relative",
        }}
      >
        <span
          style={{
            fontSize: "22px",
          }}
        >
          {icono}
        </span>

        {badge > 0 && (
          <span
            style={{
              position: "absolute",
              top: "-6px",
              right: "-10px",
              minWidth: "18px",
              height: "18px",
              borderRadius: "999px",
              background: "#d32f2f",
              color: "#fff",
              fontSize: "10px",
              fontWeight: "800",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "0 5px",
            }}
          >
            {badge > 99 ? "99+" : badge}
          </span>
        )}
      </div>

      <span
        style={{
          fontSize: "11px",
          fontWeight: activo ? "800" : "700",
        }}
      >
        {texto}
      </span>
    </button>
  );
}

export default memo(BarraNavegacionInferior);
